import { Link } from "react-router-dom";
import { MapPin, Flag, Bike, ChevronRight } from "lucide-react";
import { StatusBadge } from "@/components/StatusBadge";
import { formatCOP, formatDateTime, formatKm } from "@/lib/format";

export const ServiceCard = ({ s, to, testId }) => {
  const body = (
    <div
      className="group rounded-2xl border border-[#27272A] bg-[#141416] p-4 transition-all hover:border-[#FF6A00]/50 sm:p-5"
      data-testid={testId}
    >
      <div className="flex items-start justify-between gap-3">
        <StatusBadge status={s.status} />
        <div className="text-right">
          <div className="font-heading text-lg font-extrabold text-white">{formatCOP(s.quoted_price)}</div>
          <div className="text-[11px] text-gray-500">
            {formatKm(s.estimated_distance_km)}{s.is_estimated_distance ? " · est." : " · vial"}
          </div>
        </div>
      </div>

      <div className="mt-4 space-y-2">
        <div className="flex items-start gap-2.5">
          <MapPin size={16} className="mt-0.5 shrink-0 text-[#FF6A00]" />
          <div className="min-w-0">
            <div className="truncate text-sm font-semibold text-white">{s.pickup_address}</div>
            <div className="text-xs text-gray-500">{s.pickup_city || "Origen"}</div>
          </div>
        </div>
        <div className="ml-[7px] h-3 w-0.5 bg-[#27272A]" />
        <div className="flex items-start gap-2.5">
          <Flag size={16} className="mt-0.5 shrink-0 text-emerald-400" />
          <div className="min-w-0">
            <div className="truncate text-sm font-semibold text-white">{s.dropoff_address}</div>
            <div className="text-xs text-gray-500">{s.dropoff_city || "Destino"}</div>
          </div>
        </div>
      </div>

      <div className="mt-4 flex items-center justify-between border-t border-[#1e1e21] pt-3 text-xs text-gray-500">
        <span>{formatDateTime(s.created_at)}</span>
        {s.driver_name ? (
          <span className="flex items-center gap-1.5 text-gray-300">
            <Bike size={13} className="text-[#FF6A00]" /> {s.driver_name}
          </span>
        ) : (
          <span className="text-gray-600">Sin conductor</span>
        )}
        {to && <ChevronRight size={16} className="text-gray-600 transition-transform group-hover:translate-x-0.5" />}
      </div>
    </div>
  );
  return to ? <Link to={to}>{body}</Link> : body;
};
